<template>
    <div class="row justify-content-center">
        <div class="col-lg-5 col-md-7">
            <div class="card bg-secondary shadow border-0">

                <div class="card-body px-lg-5 py-lg-5">
                    <div class="text-center text-muted mb-4">
                        <h1>Reset Password</h1>
                    </div>
                    <form role="form">
                        <base-input class="input-group-alternative mb-3"
                                    placeholder="Password"
                                    type="password"
                                    addon-left-icon="ni ni-lock-circle-open"
                                    :class="status($v.password)"
                                    v-model="password">
                        </base-input>
                        <div class="message" v-if="!$v.password.minLength">Password must have at least {{$v.password.$params.minLength.min}} letters.</div><br>
                        <base-input class="input-group-alternative mb-3"
                                    placeholder="Confirm Password"
                                    type="password"
                                    addon-left-icon="ni ni-lock-circle-open"
                                    :class="status($v.confirmpassword)"
                                    v-model="confirmpassword">
                        </base-input>
                        <div class="message" v-if="!$v.confirmpassword.sameAsPassword">Passwords must match</div><br>
                        <div class="text-center" v-if="loaderStatus">
                            <loader></loader>
                        </div>
                        <div class="text-center" v-else>
                            <base-button type="primary" class="my-4" @click.prevent="reset_password"> Reset Password </base-button>
                        </div>
                    </form>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-6">
                    <a href="#" class="text-light"><small><router-link to="login">Login?</router-link></small></a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Loader from "../components/Loader"
    const { required, sameAs, minLength } = require('vuelidate/lib/validators');
    export default {
        name: "ResetPassword",
        data() {
            return {
                    confirmpassword: '',
                    password: ''

            }
        },
        validations: {
            password: {
                required,
                minLength: minLength(6),
            },
            confirmpassword: {
                sameAsPassword: sameAs('password')
            }
        },
        components: {
            Loader
        },
        methods: {
            status(validation) {
                return {
                    errorBorder: validation.$error,
                    dirty: validation.$dirty,
                };
            },
            reset_password() {
                if (this.$v.$invalid) {
                    Vue.notify({ title: 'Error', text: 'There is a validation error', type: 'warn' });
                } else {
                    const data = {
                        resetId: this.$route.query.resetId,
                        password: this.password
                    }
                    this.$store.dispatch('resetPassword_function', data)
                }

            }
        },

    }
</script>

<style scoped>
    .dirty {
        border-color: #5A5;
    }

    .dirty:focus {
        outline-color: #8E8;
    }

    .errorBorder {
        border-color: red;

    }

    .errorBorder:focus {
        outline-color: #F99;
    }
    .message{
        color: #f57f6c;
        font-size: 0.75rem;
        margin-left: 24px;
        margin-top: 0.3rem;
    }
</style>
